import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { withLocale } from "~/lib/utils/with-locale";
import { useCreateLocation } from "~/lib/tanstack-query/hooks/useCreateLocation";
import { InsertLocationSchema } from "~/lib/add-location/types";
import { LocationForm } from "~/lib/add-location/components/LocationForm";
import { getCmsPageContent } from "~/lib/server-functions/get-cms-page-content";
import { ContentRenderer } from "~/components/ContentRenderer";
import z from "zod";

export const Route = createFileRoute("/advertiser/_assistant/add-location")({
  component: RouteComponent,
  loader: async ({ location }) => {
    let cmsContent: Awaited<ReturnType<typeof getCmsPageContent>>["content"] =
      [];
    try {
      const result = await getCmsPageContent({
        data: { slug: "/add-location" },
      });
      if (result.content?.length) cmsContent = result.content;
    } catch {
      // No CMS content for this slug; show form only
    }
    return { cmsContent };
  },
});

function RouteComponent() {
  const { cmsContent } = Route.useLoaderData();
  const navigate = useNavigate();
  const { mutateAsync: createLocation } = useCreateLocation();

  const handleSubmit = async (values: z.infer<typeof InsertLocationSchema>) => {
    // Create the location
    await createLocation(values);
    // Navigate to locations page after successful creation
    navigate({ to: withLocale("/locations") });
  };

  return (
    <>
      <LocationForm mode="create" onSubmit={handleSubmit} />
      {cmsContent.length > 0 && (
        <div className="mt-8">
          {cmsContent.map((item: { uid: number }) => (
            <ContentRenderer key={item.uid} item={item} />
          ))}
        </div>
      )}
    </>
  );
}
